import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ children }) => {
  const { isLoggedIn, session } = useAuth();

  // Check if user is logged in and has a valid token
  if (!isLoggedIn || !session?.token) {
    return <Navigate to="/sign-in" replace />;
  }

  return children;
};

export default PrivateRoute;
